import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7382a0c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "labelInput" }
const _hoisted_3 = {
  key: 1,
  class: "col-4"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "labelInput" }, "Amount", -1))
const _hoisted_6 = ["onUpdate:modelValue", "readonly"]
const _hoisted_7 = { class: "labelInput" }
const _hoisted_8 = {
  key: 0,
  class: "col-6"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-end mt-3"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedByCategory, (propertyConfig, key, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_1, [
          key
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.checkValue(key) == 'true' ? (_ctx.groupedByCategory[key][0].isUnitCalculated ? 'col-4' : 'col-6') : 'col-12')
                }, [
                  _createElementVNode("strong", _hoisted_2, _toDisplayString(key), 1),
                  _createVNode(_component_form_field, {
                    type: "select",
                    list: _ctx.yesOrNoSelect,
                    modelValue: _ctx.checkValue(key),
                    "onUpdate:modelValue": ($event: any) => (_ctx.updateDictionaryKey($event, key)),
                    readonly: _ctx.isReadOnly
                  }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
                ], 2),
                (_ctx.checkValue(key) == 'true')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.groupedByCategory[key][0].isUnitCalculated ? 'col-4' : 'col-6')
                    }, [
                      _createVNode(_component_form_field, {
                        type: "select-string",
                        labelKey: "Details",
                        labelValue: "Details",
                        list: _ctx.groupedByCategory[key].map(x => x.name),
                        modelValue: _ctx.checkIfSubValue(key),
                        "onUpdate:modelValue": ($event: any) => (_ctx.updateDetail($event, key)),
                        readonly: _ctx.isReadOnly
                      }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.groupedByCategory[key][0].isUnitCalculated && _ctx.checkMiddleValue(key))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: 1,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.selectedValuesAmount[_ctx.getSelectedKey(key)]) = $event),
                          readonly: _ctx.isReadOnly
                        }, null, 8, _hoisted_6), [
                          [_vModelText, _ctx.selectedValuesAmount[_ctx.getSelectedKey(key)]]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(propertyConfig, (conf, propIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(conf.isUnitCalculated && _ctx.checkValue(conf.name) == 'true' ? 'col-6' : 'col-12')
                  }, [
                    _createElementVNode("strong", _hoisted_7, _toDisplayString(conf.name), 1),
                    _createVNode(_component_form_field, {
                      type: "select",
                      list: _ctx.yesOrNoSelect,
                      modelValue: _ctx.checkValue(conf.name),
                      "onUpdate:modelValue": ($event: any) => (_ctx.updateDictionaryKey($event, conf.name)),
                      readonly: _ctx.isReadOnly
                    }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
                  ], 2),
                  (conf.isUnitCalculated && _ctx.checkValue(conf.name) == 'true')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_form_field, {
                          type: "number",
                          labelKey: "Amount",
                          labelValue: "Amount",
                          placeholderKey: "Amount",
                          placeholderValue: "Amount",
                          min: 1,
                          modelValue: _ctx.selectedValuesAmount[conf.name],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.selectedValuesAmount[conf.name]) = $event),
                          readonly: _ctx.isReadOnly
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
        ])
      ]))
    }), 128)),
    (!_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Previous",
              text: "Previous"
            })
          ]),
          _createElementVNode("button", {
            class: "btn btn-tertiary",
            disabled: _ctx.checkIfDisabled,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateAdditionalProperties()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Continue",
              text: "Continue"
            })
          ], 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ]))
}